import { useEffect } from 'react';

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Junior Chamber International",
  "alternateName": "JCI",
  "url": "https://jci.cc",
  "logo": "https://jci.cc/assets/logo.png",
  "sameAs": [
    "https://www.linkedin.com/company/jci/",
    "https://twitter.com/JCINews",
    "https://www.facebook.com/JCINews",
    "https://www.youtube.com/user/jciinc",
    "https://www.instagram.com/jci_hq/"
  ],
  "foundingDate": "1915",
  "description": "Junior Chamber International (JCI) is a nonprofit organization of young active citizens age 18 to 40 who are engaged and committed to creating impact in their communities. Active in more than 100 countries, JCI provides development opportunities that empower young people to create positive change.",
  "numberOfEmployees": {
    "@type": "QuantitativeValue",
    "value": 148122
  },
  "areaServed": "Worldwide",
  "memberOf": {
    "@type": "Organization",
    "name": "United Nations"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "General Inquiries",
    "url": "https://jci.cc/contact"
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "JCI Development Councils Youth Futures Observatory",
  "alternateName": "JCI DC Youth Futures Observatory",
  "url": "https://jci-futures-observatory.lovable.app/",
  "description": "Modern and innovative observatory of Junior Chamber International with data, indicators and impact metrics of global young leaders.",
  "publisher": {
    "@type": "Organization",
    "name": "Junior Chamber International"
  },
  "inLanguage": ["en", "pt", "es", "fr", "ja"]
};

export function OrganizationSchema() {
  useEffect(() => {
    // Check if scripts already exist to avoid duplicates
    const existingOrgScript = document.querySelector('script[data-schema="organization"]');
    const existingWebScript = document.querySelector('script[data-schema="website"]');
    
    if (!existingOrgScript) {
      const orgScript = document.createElement('script');
      orgScript.type = 'application/ld+json';
      orgScript.setAttribute('data-schema', 'organization');
      orgScript.textContent = JSON.stringify(organizationSchema);
      document.head.appendChild(orgScript);
    }
    
    if (!existingWebScript) {
      const webScript = document.createElement('script');
      webScript.type = 'application/ld+json';
      webScript.setAttribute('data-schema', 'website');
      webScript.textContent = JSON.stringify(websiteSchema);
      document.head.appendChild(webScript);
    }
    
    return () => {
      // Cleanup on unmount
      const orgScript = document.querySelector('script[data-schema="organization"]');
      const webScript = document.querySelector('script[data-schema="website"]');
      if (orgScript) orgScript.remove();
      if (webScript) webScript.remove();
    };
  }, []);

  return null;
}
